import React, { forwardRef } from "react";

import { cn } from "../cn";

export const Label = forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(function Label({ className, ...props }, ref) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      ref={ref}
      className={cn("tw-font-sans tw-text-sm tw-font-medium tw-leading-none tw-text-foreground", "peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70", className)}
      {...props}
    />
  );
});
